/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Upgrade_SubtitleInputs */



/**
* | output |
* | --- |
* | "Daily allowance · 1 model" |
*
* @param {Sidebar_Upgrade_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sidebar_upgrade_subtitle = /** @type {((inputs?: Sidebar_Upgrade_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Upgrade_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tagesguthaben · 1 Modell")
	return /** @type {LocalizedString} */ ("Daily allowance · 1 model")
});